import CountryFlag from "../components/CountryFlag";
import { MapPin, Globe, Users } from "lucide-react";
import { useTranslation } from "react-i18next";

import mapImage from "../assets/map.webp";

// Mobile-optimized Country Card Component
const CountryCard = ({ country }) => {
  return (
    <div
      className="group bg-[#0F1B2D] rounded-xl p-4 hover:bg-[#1a2b42] cursor-pointer border border-transparent hover:border-[#C5A66A]/20"
      style={{ willChange: "transform, opacity" }}
    >
      <div className="text-center">
        <div className="mb-3">
          <CountryFlag
            countryCode={country.countryCode}
            alt={country.name}
            title={country.name}
            style={{
              width: "2.5rem",
              height: "2.5rem",
              borderRadius: "50%",
              objectFit: "cover",
              border: "2px solid #C5A66A",
              boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
            }}
          />
        </div>
        <h3 className="font-semibold text-white text-sm mb-1">
          {country.name}
        </h3>
        <div className="flex items-center justify-center gap-1 text-xs text-[#C5A66A] font-medium">
          <MapPin size={12} />
          <span>{country.city}</span>
        </div>
      </div>
    </div>
  );
};

// Global Presence Section
const GlobalPresence = () => {
  const { t } = useTranslation();

  const countries = [
    {
      name: t("globalPresence.countries.germany.name"),
      countryCode: "DE",
      city: t("globalPresence.countries.germany.city"),
    },
    {
      name: t("globalPresence.countries.uae.name"),
      countryCode: "AE",
      city: t("globalPresence.countries.uae.city"),
    },
    {
      name: t("globalPresence.countries.singapore.name"),
      countryCode: "SG",
      city: t("globalPresence.countries.singapore.city"),
    },
    {
      name: t("globalPresence.countries.india.name"),
      countryCode: "IN",
      city: t("globalPresence.countries.india.city"),
    },
    {
      name: t("globalPresence.countries.usa.name"),
      countryCode: "US",
      city: t("globalPresence.countries.usa.city"),
    },
    {
      name: t("globalPresence.countries.hongkong.name"),
      countryCode: "HK",
      city: t("globalPresence.countries.hongkong.city"),
    },
  ];

  return (
    <section className="pt-32 pb-20 bg-[#0F1B2D] text-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="font-playfair text-[#C5A66A] text-4xl lg:text-5xl font-bold mb-6">
            {t("globalPresence.title")}
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            {t("globalPresence.subtitle")}
          </p>
        </div>

        <div className="bg-[#1a2b42] rounded-2xl p-8 lg:p-12">
          <div className="h-48 sm:h-64 md:aspect-video md:h-auto bg-[#2a3f5f] rounded-xl overflow-hidden relative">
            <div className="w-full h-full">
              <img
                src={mapImage}
                alt="Global Presence Map"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-4 mt-8">
            {countries.map((country, index) => (
              <div
                key={index}
                className="w-[calc(50%-0.5rem)] md:w-[calc(33.333%-0.67rem)] lg:w-[calc(20%-0.8rem)]"
              >
                <CountryCard country={country} />
              </div>
            ))}
          </div>

          <div className="mt-8 text-center">
            <div className="inline-flex items-center gap-2 sm:gap-3 bg-[#0F1B2D] px-4 sm:px-6 py-2 sm:py-3 rounded-full">
              <Globe size={14} className="text-[#C5A66A] sm:w-4 sm:h-4" />
              <span className="text-white font-medium text-xs sm:text-sm">
                {t("globalPresence.stats.countries")}
              </span>
              <span className="text-gray-300 text-xs sm:text-sm">•</span>
              <Users size={14} className="text-[#C5A66A] sm:w-4 sm:h-4" />
              <span className="text-[#C5A66A] font-medium text-xs sm:text-sm">
                {t("globalPresence.stats.partners")}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GlobalPresence;
